module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("global-navigation-container " + (_vm.componentParams.template))
  }, [(_vm.componentParams.template === "top") ? [_c('menu-top', {
    attrs: {
      "data": _vm.api_response
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b00c2694"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/Navigation.vue
// module id = 265
// module chunks = 35